export default __webpack_public_path__ + "static/media/sortIconUp.2d56864d.svg";